module.exports = __webpack_public_path__ + "img/txp3.f02ab346.jpg";